import { fieldName } from './formFields';

const texts = {
  verifyNutritionFactsTitle: 'Estimated nutrition facts',
  verifyNutritionFactsDescription: 'Get an estimated nutritional breakdown per serving, based on your ingredients',
  checkNutritionFacts: 'Check Nutrition Facts',
  recipesEditorTitle: 'Recipe Editor',
  back: 'View Recipes',
  addRecipe: 'Add New Recipe',
  editRecipe: 'Edit Recipe',
  recipeSaved: 'Recipe saved successfully',
  recipeUpdated: 'Recipe updated successfully',
  prepUnit: 'minutes',
  yes: 'Yes',
  no: 'No',
  validation: {
    requiredField: 'Required',
    positiveNumber: 'Only positive numbers',
    integerNumber: 'Only integer numbers',
    onlyNumbers: 'Only numbers or decimal numbers allowed',
    errorsFound: 'Some fields contain errors or are missing. Please check.',
    noTags: 'Please select at least one tag',
  },
  errorOnNutritionFactsCheck: 'Could not check the nutrition facts: "{error}"',
  errorNoNutritionFacts: 'The answer did not include any nutrition facts',
  errorNutritionFactsServer: 'The server answered with an error',
  errorNoIngredients: 'There are no ingredients to verify. Please add some before submitting the request.',
  submitButton: 'Save Recipe',
  labels: {
    image: 'Recipe Image',
    tags: 'Suitable For',
    macros: 'Macros Per Serving',
    ingredients: 'Ingredients',
    instructions: 'Instructions',
  },
  field: {
    [fieldName.NAME]: {
      label: 'Recipe Name',
    },
    [fieldName.DESCRIPTION]: {
      label: 'Recipe Description',
    },
    [fieldName.SERVINGS]: {
      label: 'No. of Servings',
    },
    [fieldName.SCALE]: {
      label: 'Scale this recipe',
    },
    [fieldName.PREPARATION_TIME]: {
      label: 'Prep Time',
    },
    [fieldName.COOKING_TIME]: {
      label: 'Cook Time',
    },
  },
};

export default texts;
